import { HTTPClient, propsToDate, propsToDatePaged } from "@abaco/web-common/src/HTTP";
import { dbGIStoStandardPage, PagedResults, PagingParams } from "@abaco/web-common/src/Paging";
import { Conversation, Message } from "../models/Notification";

export default class NotificationsApi {

    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    public async getConversation(pkCuaa: number, date: Date | null, paging: PagingParams): Promise<PagedResults<Conversation>> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/messages/conversations`, {
            params: {
                sort: "-date_update",
                filter: date ? `date_update ge ${date.getTime()}` : undefined,
                subject_id: pkCuaa,
                offset: paging.offset,
                count: paging.count,
            }
        });
        return res.data;
    }

    public async getAllConversations(pkCuaa: number, date: Date | null): Promise<Conversation[]> {
        let count = 0;
        let res: Conversation[] = [];
        let totalcount = 0;
        do {
            const curPage = await this.getConversation(pkCuaa, date, { offset: count, count: 300 });
            count += curPage.count;
            totalcount = curPage.totalcount;
            res = [...res, ...curPage.records];
        } while (count < totalcount)

        return res;
    }

    public async getConversationMessages(conversationId: number, date: Date | null, paging: PagingParams): Promise<PagedResults<Message>> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/messages/conversations/${conversationId}/messages`, {
            params: {
                sort: "-prog_message",
                filter: date ? `date_send ge ${date.getTime()}` : undefined,
                offset: paging.offset,
                count: paging.count,
            }
        });
        return res.data;
    }

    public async getAllConversationMessages(conversationId: number, date: Date | null): Promise<Message[]> {
        let count = 0;
        let res: Message[] = [];
        let totalcount = 0;
        do {
            const curPage = await this.getConversationMessages(conversationId, date, { offset: count, count: 300 });
            count += curPage.count;
            totalcount = curPage.totalcount;
            res = [...res, ...curPage.records];
        } while (count < totalcount)

        return res;
    }


    // public async getNotificationsByWeek(pkCuaa: number, startDate: Date, endDate: Date, paging: PagingParams): Promise<PagedResults<Notification>> {
    //     filter: filter ? `subject_full_name like ${filter.toUpperCase()}` : undefined,
    //     const res = await this.http.get(`/sitiagri-rest-api/api_sso/v1/messages/conversations`, {
    //         params: {
    //             sort: "-date_update",
    //             subject_id: pkCuaa,
    //             offset: paging.offset,
    //             count: paging.count,
    //         }
    //     });
    //     return res.data;
    // }

}
